import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PersonalDataForm } from './personal-data.form';
import { LiabilityDataModel } from '../models/liability-data.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaymentMethodFormControl } from './payment-method.control';
import { PaymentMethodUtils } from '../utils/payment-method-utils';

export class PaymentForm extends FormGroup<{
  paymentMethod: PaymentMethodFormControl;
  personalData: PersonalDataForm;
  imojeTos: FormControl<boolean>;
}> {
  public imojeTosRequired$: Observable<boolean>;

  constructor() {
    super({
      paymentMethod: new PaymentMethodFormControl(),
      personalData: new PersonalDataForm(),
      imojeTos: new FormControl<boolean>(false)
    });
    this.imojeTos.setValidators(() => this.validateImojeTos());
    this.paymentMethod.valueChanges.subscribe(() => this.imojeTos.updateValueAndValidity());
    this.imojeTosRequired$ = this.paymentMethod.valueChanges.pipe(
      map(() => PaymentMethodUtils.isImojePaymentMethod(this.paymentMethod.value))
    );
  }

  get paymentMethod() {
    return this.get('paymentMethod') as PaymentMethodFormControl;
  }

  get personalData() {
    return this.get('personalData') as PersonalDataForm;
  }

  get imojeTos() {
    return this.get('imojeTos') as FormControl<boolean>;
  }

  fill(data: LiabilityDataModel) {
    this.personalData.name.setValue(data.name);
    this.personalData.surname.setValue(data.surname);
    this.personalData.email.setValue(data.email);
  }

  private validateImojeTos(): { [key: string]: any } | null {
    return PaymentMethodUtils.isImojePaymentMethod(this.paymentMethod.value) && !this.imojeTos.value
      ? { required: true }
      : null;
  }
}
